import React from "react";
import {FormattedMessage} from "react-intl";
import clsx from "classnames";

// Small-print trade mark notice: "SepaHeld®" is a registered EU trade mark
// (EUTM 019323578) of d-automation GmbH. Rendered below the login/register
// forms and at the bottom of the authenticated app's sidebar. `className`
// replaces the default small grey styling so callers can adapt size/colour.
const DEFAULT_CLASSES = "text-xs text-slate-400";

const TrademarkNotice = ({className = DEFAULT_CLASSES}) => (
    <p className={clsx("leading-relaxed", className)} data-testid="trademark-notice">
        <FormattedMessage
            id="brand.trademark.notice"
            defaultMessage="SepaHeld® is a registered European Union trade mark (EUTM 019323578) of d-automation GmbH."
        />
    </p>
);

export default TrademarkNotice;
